import { BaseApiService } from '@shared/services/BaseApiService';

class ResetPasswordServiceClass extends BaseApiService {
  constructor(opts) {
    super(opts);
  }

  send(params = {}) {
    return this.http.post('/send', params);
  }
  reset(params = {}) {
    return this.http.post('/save', params);
  }
  generate() {
    return this.http.get('/generate');
  }

  changePassword(params) {
    return this.http.post('/save', params);
  }
  
  checkLastSent(params) {
    return this.http.post('/check-sent', params);
  }
}

export const ResetPasswordService = new ResetPasswordServiceClass({
  api_version: 2,
  resource: '/restore-password'
});
